// ─── Chaves de storage ────────────────────────────────────────────────────────

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
} as const;

// ─── Tokens internos ──────────────────────────────────────────────────────────

export interface AuthTokens {
  accessToken: string;
  refreshToken?: string | null;
}

// ─── Requests ─────────────────────────────────────────────────────────────────

export interface LoginRequest {
  email: string;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

// ─── Responses ────────────────────────────────────────────────────────────────

/** Resposta do /autenticacao/login — apenas confirma envio do magic link */
export interface LoginResponse {
  message?: string;
}

/**
 * Resposta do /autenticacao/callback (magic link) e do /autenticacao/refresh.
 * O SGI pode implementar refresh token rotation — nesse caso `refresh_token`
 * virá preenchido com um novo valor. Se não vier, mantém-se o token atual.
 */
export interface RefreshTokenResponse {
  access_token: string;
  /** Presente quando o SGI usa refresh token rotation */
  refresh_token?: string;
  token_type?: string;
}

/** Alias para o callback — mesma forma da resposta de refresh */
export type CallbackResponse = RefreshTokenResponse;